import { gql, TypedDocumentNode } from '@apollo/client'
import type { FunctionCodeFragment } from './__generated__/FunctionCodeFragment'

export const functionCodeFragment: TypedDocumentNode<FunctionCodeFragment> = gql`
  fragment FunctionCodeFragment on FunctionCode {
    actualCoefficient
    code
    id
    name
    payrollCoefficient
  }
`
